$('.qa_slider').slick({
  autoplay: false,
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 3,
  dotsClass: 'slick-dots',
  prevArrow: '<img src="/icon/btn_left.svg" class="slide-arrow prev-arrow">',
  nextArrow: '<img src="/icon/btn_right.svg" class="slide-arrow next-arrow">',
  dots: true,
  responsive: [
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: "8%"
      }
    },
    {
      breakpoint: 426,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: "8%"
      }
    }
  ]
});
